import { Divider, List, ListItem, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import {
  spacing,
  typography,
  colors,
} from "../../../../../../../../../../assets/styles/tokens";
import {
  formatPercent,
  formatUsd,
} from "../../../../../../../DashboardDesktop/Anomalies/AnomaliesTabs/Utils/anomaliesColumns";

interface IncomeGapsMoreMetricsProps {
  row: Record<string, any>;
}

const metricRow = (label: string, value: string) => (
  <>
    <ListItem
      sx={{
        width: "100%",
        display: "block",
        p: spacing.Spacing.sm.$value,
      }}
    >
      <Typography
        sx={{
          fontSize: typography.Size.Text.xs.$value,
          lineHeight: typography.Line_height.text.xs.$value,
          fontWeight: typography.Font_weight.Medium.$value,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {label}
        <Box
          sx={{
            fontWeight: typography.Font_weight.Semibold.$value,
            fontSize: typography.Size.Text.xs.$value,
          }}
        >
          {value}
        </Box>
      </Typography>
    </ListItem>
    <Divider />
  </>
);

const IncomeGapsMoreMetrics = ({ row }: IncomeGapsMoreMetricsProps) => {
  return (
    <Stack>
      <List sx={{ pb: 0, color: colors.GrayLightMode[900].$value }}>
        {metricRow("AVERAGE DEAL CPA", formatUsd(row.cpa_deal))}
        {metricRow("QFTD", String(row.qftd ?? ""))}
        {metricRow("AVERAGE DEAL %", formatPercent(row.rs_deal))}
        {metricRow("NET REVENUE", formatUsd(row.net_revenue))}
      </List>
    </Stack>
  );
};

export default IncomeGapsMoreMetrics;
